export enum NavigationPath {
  Homepage = '/',
  SubscriptionWithBenefits = '/pakiet-korzysci/',
  GastroCardBoost = '/doladowanie-smaku/',
  GastroCard = '/podwojna-radosc-2026-2027/',
  EndlessHoliday = '/wakacje-w-nieskonczonosc/',
  ChristmasVoucher = '/voucher-swiateczny/',
  GastroCardDynamic = '/podwojna-radosc-2025-plus/',
  GastroCardBlackWeek = '/podwojna-radosc-black-week/',
  GastroCardChristmas = '/podwojna-radosc-oferta-swiateczna/',
  GastroCardFebruary2025 = '/podwojna-radosc-oferta-luty/',
  GastroCardFebruary2026 = '/podwojna-radosc-oferta-luty-2026/',
  GastroCardPromo20272028 = '/podwojna-radosc-na-lata-2027-2028/',
  GastroCardAugust2025 = '/podwojna-radosc-oferta-sierpien/',
  GastroCardBlackWeek20 = '/podwojna-radosc-black-week-20/',
  CodeConversion = '/ulepszanie-kodu/',
  SubscriptionContract = '/subskrypcja/',
  Rules = '/regulamin/',
  GoHoliday = '/go-holiday/',
  NotFound = '/nie-znaleziono/',
}
